import React, { useMemo } from "react";
import {
  BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer,
  XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";

const COLORS = ["#0B1E3F", "#C9A961", "#4B84D6", "#6B21A8", "#15803D", "#B45309", "#334155"];

export default function LeadsAnalytics({ leads }) {
  const byCountry = useMemo(() => {
    const map = {};
    leads.forEach((l) => { map[l.target_country] = (map[l.target_country] || 0) + 1; });
    return Object.entries(map).map(([name, value]) => ({ name, value })).sort((a, b) => b.value - a.value);
  }, [leads]);

  const byVisa = useMemo(() => {
    const map = {};
    leads.forEach((l) => { map[l.visa_type] = (map[l.visa_type] || 0) + 1; });
    return Object.entries(map).map(([name, value]) => ({ name, value })).sort((a, b) => b.value - a.value);
  }, [leads]);

  if (!leads.length) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
      <div className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm">
        <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Leads by Country</div>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={byCountry} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748B" }} interval={0} angle={-15} textAnchor="end" height={50} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#64748B" }} />
            <Tooltip cursor={{ fill: "#F8FAFC" }} contentStyle={{ border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 12 }} />
            <Bar dataKey="value" fill="#0B1E3F" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm">
        <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Leads by Visa Type</div>
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie data={byVisa} dataKey="value" nameKey="name" cx="45%" cy="50%" outerRadius={80} innerRadius={45}>
              {byVisa.map((entry, i) => <Cell key={entry.name} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip contentStyle={{ border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="flex flex-wrap gap-2 mt-2">
          {byVisa.map((v, i) => (
            <div key={v.name} className="flex items-center gap-1.5 text-xs text-slate-600">
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
              {v.name} · {v.value}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
